import api from '../../services/api';
import { getRefreshTokenBody } from '../../services/authTokens';

export async function register({ email, password, displayName }) {
  const { data } = await api.post('/auth/register', { email, password, displayName });
  return data;
}

export async function login({ email, password }) {
  const { data } = await api.post('/auth/login', { email, password });
  return data;
}

export async function refresh(refreshToken) {
  const body = refreshToken ? { refreshToken } : getRefreshTokenBody();
  const { data } = await api.post('/auth/refresh', body);
  return data;
}

export async function logout() {
  await api.post('/auth/logout', getRefreshTokenBody());
}

export async function verifyEmail(token) {
  const { data } = await api.post('/auth/verify-email', { token });
  return data;
}

export async function forgotPassword(email) {
  const { data } = await api.post('/auth/forgot-password', { email });
  return data;
}

export async function resetPassword({ token, password }) {
  const { data } = await api.post('/auth/reset-password', { token, password });
  return data;
}
